import { styled } from "@mui/material/styles";
import { Box, CircularProgress, Stack } from "@mui/material";
import { APP_COLORS } from "../../enums";

export const ProfileCompletionProgressWrapper = styled(Box)({
  position: "relative",
  display: "inline-flex",
});

export const ProfileCompletionProgressGradient = styled("svg")({
  width: 0,
  height: 0,
  position: "absolute",
});

export const ProfileCompletionProgressBackground = styled(CircularProgress)({
  color: APP_COLORS.greyLight2,
});

export const ProfileCompletionProgressForeground = styled(CircularProgress)({
  position: "absolute",
  left: 0,
  "& .MuiCircularProgress-circle": {
    stroke: "url(#profileProgressGradient)",
  },
});

export const ProfileCompletionProgressContent = styled(Stack)({
  top: 0,
  left: 0,
  bottom: 0,
  right: 0,
  position: "absolute",
  alignItems: "center",
  justifyContent: "center",
});
